import { Routes } from '@angular/router';
import { TicketList } from './features/user/components/Tickets-list/ticket-list/ticket-list';
import { StandardTable } from './shared/components/standard-table/standard-table/standard-table';
import { AdminTable } from './features/admin/components/admin-table/admin-table';
import { Purchase } from './features/user/components/purchase/purchase/purchase';
import { Sidebar } from './features/admin/components/sidebar/sidebar/sidebar';
import { LoginForm } from './features/admin/components/login-form/login-form';
import { authGuard } from './core/guards/auth.guard';
import { loginGuard } from './core/guards/login.guard';
import { Card } from './features/admin/components/card/card';
import { Account } from './features/admin/components/account/account';
import { Order } from './features/admin/components/order/order';
import { Lottery } from './features/admin/components/lottery/lottery';
import { Result } from './features/admin/components/result/result';
import { Dashboard } from './features/admin/components/dashboard/dashboard';
import { Setting } from './features/admin/components/setting/setting';
import { NotFoundComponent } from './shared/components/not-found/not-found';
import { ConfirmedOrder } from './features/admin/components/confirmed-order/confirmed-order';

export const routes: Routes = [
  { path: '', component: TicketList },
  { path: 'admin', component: LoginForm, canActivate: [loginGuard] },
  {
    path: 'admin',
    component: Sidebar,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: Dashboard },
      { path: 'profile', component: AdminTable }, 
      { path: 'ticket', component: AdminTable }, 
      { path: 'lottery', component: Lottery },
      { path: 'card', component: Card },   
      { path: 'account', component: Account },
      { path: 'order', component: Order },  
      { path: 'result', component: Result },  
      { path: 'settings', component: Setting },
      { path: 'confirmed-order', component: ConfirmedOrder },
    ],
  },
  { path: 'purchase', component: Purchase },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '/404' }
];
